import * as React from 'react';
import { ActivityDefinition, ActivitySchedule, ActivityState } from '../../../../model/activities';
import { Grid, FormControlLabel, Checkbox, Divider } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import { Select, SelectItem } from '../../../../ui-components/select/Select';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import { tag } from '../../../../model/tag';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';
import DeleteButton from '../../../../ui-components/Button/DeleteButton';
import Button from '../../../../ui-components/Button/Button';
import { addDays, getDayPropByDayNumber } from '../dateUtils';
import SendButton from '../../../../ui-components/Button/SendButton';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';
import { trainer } from '../../../../model/trainer';
import { TrainerDisplay } from '../TrainerDisplay';
import { AlertModified } from './AlertModified';
import { AlertApproval } from './AlertApproval';

interface IProps {
    activity: ActivityDefinition;
    schedules: ActivitySchedule[];
    setActivity: (activity: ActivityDefinition) => any;
    classes: any;
    tags: tag[];
    onCancel: () => any;
    onDelete: (id: string) => any;
    onSave: (activity: ActivityDefinition) => any;
    onApprove: (activity: ActivityDefinition) => any;
    openCalendar: () => any;
    addSchedules: (schedules: ActivitySchedule[]) => any;
    removeSchedules: (ids: string[]) => any;
    trainers: trainer[];
}



export const Details = (props: IProps) => {
    const { activity, schedules, tags } = props;
    const [alertScheduleModified, setAlertScheduleModified] = React.useState(false);
    const [alertApproval, setAlertApproval] = React.useState(false);
    const [scheduleToAdd, setScheduleToAdd] = React.useState<ActivitySchedule[]>();
    const [scheduleToRemove, setScheduleToRemove] = React.useState<ActivitySchedule[]>();
    const [selectedTrainers, setSelectedTrainers] = React.useState<trainer[]>([]);
    const [selectedTrainer, setSelectedTrainer] = React.useState<SelectItem>();
    const saveEnabled = () => {
        return true;
    }
    React.useEffect(() => {
        if (props.trainers && props.trainers.length > 0) {
            const t = props.trainers.filter(a => activity.trainerIds.indexOf(a._id) > -1);
            setSelectedTrainers(t);
        }
    }, [activity, props.trainers])
    const draft = activity.state === ActivityState.draft;
    const findSchedulesToAdd = () => {
        let sorted = [...schedules].sort((a, b) => (a.date.getTime() - b.date.getTime()));
        let lastSchedule = sorted[schedules.length - 1];
        let dt = addDays(lastSchedule.date, 1);
        let ret: ActivitySchedule[];
        const expiration = new Date(activity.expiresOn.getFullYear(), activity.expiresOn.getMonth(), activity.expiresOn.getDate(), 23, 59, 0)
        while (dt < expiration) {
            const dayDef = getDayPropByDayNumber(dt.getDay());
            if (activity.scheduleDefinition[dayDef] && activity.scheduleDefinition[dayDef].duration) {
                const s = getSchedule(activity, dt, dayDef)
                if (!ret) ret = [];
                ret.push(s);
            }
            dt = addDays(dt, 1);
        }

        const start = new Date(activity.validFrom.getFullYear(), activity.validFrom.getMonth(), activity.validFrom.getDate())
        let firstSchedule = sorted[0];
        dt = addDays(firstSchedule.date, -1);
        while (dt > start) {
            const dayDef = getDayPropByDayNumber(dt.getDay());
            if (activity.scheduleDefinition[dayDef] && activity.scheduleDefinition[dayDef].duration) {
                const s = getSchedule(activity, dt, dayDef)
                if (!ret) ret = [];
                ret.push(s);
            }
            dt = addDays(dt, -1);
        }
        return ret;
    }
    const findSchedulesToRemove = () => {
        const sorted = [...schedules].sort((a, b) => (a.date.getTime() - b.date.getTime()));
        let lastSchedule = sorted[schedules.length - 1];
        let ret: ActivitySchedule[];
        const expiration = new Date(activity.expiresOn.getFullYear(), activity.expiresOn.getMonth(), activity.expiresOn.getDate(), 23, 59, 0)
        let i = schedules.length - 1;
        while (lastSchedule.date > expiration) {
            if (!ret) ret = [];
            ret.push(lastSchedule);
            i--;
            lastSchedule = sorted[i];
        }

        const start = new Date(activity.validFrom.getFullYear(), activity.validFrom.getMonth(), activity.validFrom.getDate())
        let firstSchedule = sorted[0];
        i = 0
        while (firstSchedule.date < start) {
            if (!ret) ret = [];
            ret.push(firstSchedule);
            i++;
            firstSchedule = sorted[i];
        }
        return ret;
    }

    const save = () => {
        const schedulesToAdd = findSchedulesToAdd();
        const schedulesToRemove = findSchedulesToRemove();
        if (schedulesToAdd || schedulesToRemove) {
            setScheduleToAdd(schedulesToAdd);
            setScheduleToRemove(schedulesToRemove);
            setAlertScheduleModified(true);
        }
        else
            props.onSave(activity);
    }
    const confirm = () => {
        if (scheduleToAdd && scheduleToAdd.length)
            props.addSchedules(scheduleToAdd);
        if (scheduleToRemove && scheduleToRemove.length)
            props.removeSchedules(scheduleToRemove.map(a => a._id));
        props.onSave(activity);
    }
    const approve = () => {
        props.onApprove(activity);
    }

    const availableTrainers = () => {
        const ret = [];
        (props.trainers || []).forEach(a => {
            if (selectedTrainers && selectedTrainers.findIndex(t => t._id === a._id) === -1)
                ret.push({ name: a.name, value: a._id });
        });
        return ret;
    }
    const addTrainer = () => {
        const toAdd = selectedTrainer;
        if (selectedTrainer && selectedTrainers.findIndex(a => a._id === toAdd.value) === -1) {
            const newTrainers = [...selectedTrainers, props.trainers.find(a => a._id === toAdd.value)]
            setSelectedTrainers(newTrainers);
            props.setActivity({ ...activity, trainerIds: newTrainers.map(a => a._id) });
        }
    }
    const removeTrainer = (id: string) => {
        var toRemove = selectedTrainers.findIndex(a => a._id === id);
        if (toRemove > -1) {
            selectedTrainers.splice(toRemove, 1);
            const newList = [...selectedTrainers];
            setSelectedTrainers(newList);
            props.setActivity({ ...activity, trainerIds: newList.map(a => a._id) });
        }
    }
    return <>
        <Grid container sm={12}>
            <Grid item sm={8}>
                <TextField disabled={!draft} label='Nome visualizzato' value={activity.displayName} onChange={val => props.setActivity({ ...activity, displayName: val })} />
            </Grid>
            <Grid item xs={4} className={props.classes.calendarButtonContainer}>
                <Button className={props.classes.calendarButton} onClick={props.openCalendar}>Calendario</Button>
            </Grid>
        </Grid>
        <Grid item sm={12}>
            <TextField disabled={!draft} label='Descrizione' value={activity.description} onChange={val => props.setActivity({ ...activity, description: val })} />
        </Grid>
        <Grid item sm={12} className={props.classes.newActivityDate}>
            <Select disabled={!draft} fullWidth
                selected={activity.tag ? { name: activity.tag.description, value: activity.tag.code } : undefined}
                items={tags.map(t => { return { name: t.description, value: t.code } })}
                onChange={(item) => props.setActivity({ ...activity, tag: tags.find(t => t.code === item.value) })} label='Tag' />
        </Grid>
        <Grid item sm={12} className={props.classes.newActivityDatesContainer}>
            <Grid item sm={6} className={props.classes.newActivityDate}>
                <DatePicker
                    key={`newActivityDefinition-from-date-picker`}
                    label="Data inizio validità"
                    fullWidth
                    value={activity.validFrom}
                    onChange={(d) => props.setActivity({ ...activity, validFrom: d })}
                />
            </Grid>
            <Grid item sm={6} className={props.classes.newActivityDate}>
                <DatePicker
                    key={`newActivityDefinition-from-date-picker`}
                    label="Data fine validità"
                    fullWidth
                    minDate={addDays(activity.validFrom, 1)}
                    value={activity.expiresOn}
                    onChange={(d) => props.setActivity({ ...activity, expiresOn: d })}
                />
            </Grid>
        </Grid>

        <Grid container>
            <Grid item sm={12}>
                <FormControlLabel className={props.classes.newActivityCheckBoxLabel}
                    control={<Checkbox disabled={!draft} checked={activity.isReservable} onChange={(e, val) => props.setActivity({ ...activity, isReservable: val })} />}
                    label={'Prenotabile'}
                />
            </Grid>
        </Grid>
        <Grid container className={props.classes.trainersContainer}>
            {draft && <>
                <Grid item sm={8}>
                    <Select fullWidth label={'Istruttori'} selected={selectedTrainer} items={availableTrainers()} onChange={(i) => { setSelectedTrainer(i) }} />
                </Grid>
                <Grid item xs={4} className={props.classes.addTrainerButtonContainer}>
                    <NewItemButton text='Aggiungi' onClick={addTrainer} disabled={!selectedTrainer} />
                </Grid>
            </>}
            <Grid container>
                <Grid item sm={12}>
                    {selectedTrainers.map(t => {
                        return <TrainerDisplay disabled={!draft} trainer={t} removeTrainer={removeTrainer} />
                    })}
                </Grid>
            </Grid>
        </Grid>
        <Divider style={{ marginTop: 20 }} />
        <Grid item sm={12} className={props.classes.buttonsContainer}>
            <ConfirmButton text='Salva' onClick={(e) => { e.preventDefault(); save(); }} disabled={!saveEnabled()} />
            <UndoButton text='Annulla' onClick={(e) => { e.preventDefault(); props.onCancel() }} />
            <DeleteButton text='Elimina' onClick={(e) => { e.preventDefault(); props.onDelete(activity._id) }} />
        </Grid>
        <Grid item sm={12} className={props.classes.buttonsContainer}>
            <SendButton disabled={activity.state !== ActivityState.draft} text={draft ? 'Approva pianificazione' : 'Attività approvata'} onClick={(e) => { e.preventDefault(); setAlertApproval(true); }} />
        </Grid>
        <AlertModified onClose={() => setAlertScheduleModified(false)}
            open={alertScheduleModified}
            classes={props.classes}
            scheduleToAdd={scheduleToAdd}
            scheduleToRemove={scheduleToRemove}
            confirm={confirm} />
        <AlertApproval open={alertApproval}
            onClose={() => setAlertApproval(false)}
            approve={approve}
            classes={props.classes} />
    </>
}

export const DateComp = (dt: Date) => {
    return <div style={{ border: '1px solid #ff6600', margin: 3, padding: '0px 3px 0px 3px' }}>{dt.toLocaleDateString()} {dt.toLocaleTimeString()}</div>
}

const getSchedule = (activity: ActivityDefinition, dt: Date, dayDef: string) => {
    return {
        isReservable: activity.isReservable,
        activityDefinitionId: activity._id,
        date: dt,
        state: activity.state,
        displayName: activity.displayName,
        description: activity.description,
        duration: activity.scheduleDefinition[dayDef].duration,
        capacity: activity.scheduleDefinition[dayDef].capacity,
        trainerIds: activity.trainerIds,
        tag: activity.tag,
    };
}
